module.exports = __webpack_public_path__ + "static/media/9DESA8.a9c7b351.jpg";